import { useTheme } from '@emotion/react';
import { Edit } from '@icon-park/react';
import { memo } from 'react';
import { useIntl } from 'react-intl';

import type { LearningResource } from '@didaskill/domain/learning-resources/types';
import { ICON_SIZES, removeButtonAppearance } from '@didaskill/ui/design-system';

import messages from './LearningResourceEditButton.messages';

type LearningResourceEditButtonProps = {
  learningResource: LearningResource;
  onUpdateLearningResource: (learningResourceId: string) => void;
};

const LearningResourceEditButtonBase = ({
  learningResource,
  onUpdateLearningResource,
}: LearningResourceEditButtonProps) => {
  const theme = useTheme();
  const intl = useIntl();

  return (
    <button
      type="button"
      onClick={() => {
        onUpdateLearningResource(learningResource.id);
      }}
      aria-label={intl.formatMessage(messages.UPDATE_LEARNING_RESOURCE)}
      css={removeButtonAppearance}
    >
      <Edit size={ICON_SIZES.MEDIUM} fill={[theme.colors.primary[500], theme.colors.primary[50]]} />
    </button>
  );
};

LearningResourceEditButtonBase.displayName = 'LearningResourceEditButton';

export const LearningResourceEditButton = memo(LearningResourceEditButtonBase);
